// @ts-nocheck

// -----------------------------
// CONFIGURACIÓN LOCAL (fácil de modificar)
const THICKNESS_STEP_CONFIG = {
  // Dominio por defecto de la tienda (se usa como fallback)
  SHOP_DOMAIN: 'gf7q0f-ma.myshopify.com',

  // Tag que identifica productos de grosor
  TAG_THICKNESS: 'grosor-type',

  // Número máximo de productos a recuperar desde la API de products.json
  PRODUCTS_LIMIT: 250,

  // Orden preferido para renderizar opciones
  PREFERRED_ORDER: ['reducido', 'standard'],

  // Permitir selección múltiple en el step (true = multi-select, false = single-select)
  MULTI_SELECT: false,

  // Si true, usar getBasicThickness() cuando no se encuentren productos o mapping
  USE_BASIC_FALLBACK: true
};

// -----------------------------
/**
 * Step específico: Grosor del Cristal
 */
class ThicknessStep extends LensConfiguratorStep {
  constructor(configurator, options = {}) {
    super(configurator, {
      ...options,
      stepKey: 'thickness',
      title: 'Grosor del Cristal',
      description: 'Selecciona el grosor del cristal'
    });
    // No cargar automáticamente aquí; init() se llamará cuando el step sea mostrado
  }

  static get STEP_CONFIG() {
    return THICKNESS_STEP_CONFIG;
  }

  async init() {
    if (typeof this.loadConfiguration === 'function') {
      await this.loadConfiguration();
    }
  }

  /**
   * Obtiene la URL correcta para las peticiones a Shopify (compatibilidad con locale)
   */
  getShopifySearchUrl() {
    const shopDomain = this.getShopifyDomain();
    return `https://${shopDomain}/products.json?limit=${ThicknessStep.STEP_CONFIG.PRODUCTS_LIMIT}`;
  }

  /**
   * Detecta el dominio de la tienda Shopify de forma más robusta
   */
  getShopifyDomain() {
    if (this.configurator && this.configurator.shopDomain) {
      return this.configurator.shopDomain;
    }
    if (window.__AINY_SHOP_DOMAIN) {
      return window.__AINY_SHOP_DOMAIN;
    }
    if (window.Shopify && window.Shopify.shop) {
      return `${window.Shopify.shop}`;
    }
    const shopifyMeta = document.querySelector('meta[name="shopify-digital-wallet"]');
    if (shopifyMeta && shopifyMeta.content) {
      const match = shopifyMeta.content.match(/([^.]+\.myshopify\.com)/);
      if (match) return match[1];
    }
    return ThicknessStep.STEP_CONFIG.SHOP_DOMAIN || 'gf7q0f-ma.myshopify.com';
  }

  /**
   * Intenta detectar el locale/idioma actual de la tienda.
   */
  getCurrentLocale() {
    if (this.configurator && this.configurator.locale) return this.configurator.locale;
    if (window.Shopify && window.Shopify.locale) return window.Shopify.locale;
    const htmlLang = document.documentElement && document.documentElement.lang;
    if (htmlLang) return htmlLang.split('-')[0];
    const ogLocale = document.querySelector('meta[property="og:locale"]');
    if (ogLocale && ogLocale.content) return ogLocale.content;
    return null;
  }

  /**
   * Construye la URL para products.json incluyendo locale cuando esté disponible
   */
  buildShopifyProductsUrl(query) {
    const shopDomain = this.getShopifyDomain();
    const locale = this.getCurrentLocale();
    let url = `https://${shopDomain}/products.json?limit=${ThicknessStep.STEP_CONFIG.PRODUCTS_LIMIT}`;
    if (query && typeof query === 'string') {
      const q = query.replace(/^\?/, '');
      if (q) url += `&${q}`;
    }
    if (locale) url += `&locale=${encodeURIComponent(locale)}`;
    return url;
  }

  async loadConfiguration() {
    if (!this.configurator.config) {
      this.configurator.config = {};
    }

    this.configurator.config.thickness = await this.loadThicknessFromShopify();

    try {
      this.render();
    } catch (e) {
      console.warn('⚠️ Error al re-renderizar ThicknessStep:', e);
    }
  }

  /**
   * Carga los grosores dinámicamente desde productos de Shopify
   */
  async loadThicknessFromShopify() {
    try {
      let products = [];
      if (window.LensStepUtils && typeof window.LensStepUtils.fetchProductsByTag === 'function') {
        products = await window.LensStepUtils.fetchProductsByTag(this.configurator, ThicknessStep.STEP_CONFIG.TAG_THICKNESS, ThicknessStep.STEP_CONFIG.PRODUCTS_LIMIT);
        console.log('🔍 Productos (via LensStepUtils) con tag grosor:', products);
      } else {
        const productsUrl = this.buildShopifyProductsUrl(`?q=tag:${ThicknessStep.STEP_CONFIG.TAG_THICKNESS}`);
        console.log('🔍 (fallback) Consultando productos de Shopify:', productsUrl);
        const response = await fetch(productsUrl);
        if (!response.ok) throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        const data = await response.json();
        products = (data.products || []).filter(p => p.tags && p.tags.includes(ThicknessStep.STEP_CONFIG.TAG_THICKNESS));
        console.log('🔍 (fallback) Productos con tag grosor:', products);
      }

      if (products.length === 0) {
        console.warn('⚠️ No se encontraron productos con tag de grosor');
        return this.getBasicThickness();
      }

      const thickness = {};
      products.forEach(product => {
        const thicknessKey = this.mapProductToThicknessKey(product);
        if (thicknessKey) {
          const price = (window.LensStepUtils && typeof window.LensStepUtils.parsePrice === 'function')
            ? window.LensStepUtils.parsePrice(product)
            : this.parsePrice(product);

          thickness[thicknessKey] = {
            name: product.title,
            description: this.extractProductDescription(product),
            price: price,
            productId: product.id,
            handle: product.handle,
            image: product.images && product.images.length > 0 ? product.images[0].src : null,
            variants: product.variants
          };
        }
      });

      if (Object.keys(thickness).length === 0) {
        console.warn('⚠️ No se pudieron mapear productos válidos para grosores');
        if (ThicknessStep.STEP_CONFIG.USE_BASIC_FALLBACK) return this.getBasicThickness();
        return {};
      }

      console.log('✅ Grosores cargados desde Shopify:', thickness);
      return thickness;
    } catch (error) {
      console.error('❌ Error cargando grosores desde Shopify:', error);
      return this.getBasicThickness();
    }
  }

  /**
   * Mapea el producto a la key correspondiente del grosor
   * Acepta el objeto producto completo para poder buscar en title/handle/tags
   */
  mapProductToThicknessKey(product) {
    // Mapeo EXCLUSIVO por handle (product.handle)
    const handle = (product.handle || '').toLowerCase().trim();

    // Mapeos exactos para handles conocidos
    const exact = {
      'cristal-reducido': 'reducido',
      'cristal-reduc': 'reducido',
      'cristal-fino-estandar': 'standard',
      'cristal-fino': 'standard',
      'cristal-estandar': 'standard',
      'grosor-estandar': 'standard',
      'grosor-reducido': 'reducido',
      'estandar': 'standard',
      'reducido': 'reducido'
    };

    if (exact[handle]) return exact[handle];

    // Si no hay exact match, usar patrones sobre el handle
    if (/reduc/.test(handle)) return 'reducido';
    if (/estandar|standard|fino/.test(handle)) return 'standard';

    // No mapear si no hay coincidencia en el handle
    console.warn('⚠️ No se pudo mapear el producto a grosor por handle:', product.handle);
    return null;
  }

  /**
   * Extrae la descripción del producto
   */
  extractProductDescription(product) {
    if (product.body_html) {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = product.body_html;
      const text = tempDiv.textContent || tempDiv.innerText || '';
      const clean = text.replace(/\s+/g, ' ').trim();
      return clean.length > 150 ? clean.substring(0, 150) + '...' : clean;
    }
    return 'Descripción no disponible';
  }

  /**
   * Muestra un mensaje de error en el contenedor
   */
  showError(message) {
    const container = document.getElementById('thickness-options');
    if (!container) return;

    container.innerHTML = `
      <div class="error-message" style="
        background: #fee;
        border: 1px solid #fcc;
        color: #c33;
        padding: 15px;
        border-radius: 5px;
        text-align: center;
        margin: 20px 0;
      ">
        <strong>Error:</strong> ${message}
      </div>
    `;
  }

  /**
   * Devuelve configuración básica de grosores por defecto
   */
  getBasicThickness() {
    console.warn('⚠️ ATENCIÓN: Usando configuración básica por defecto. Para producción, crea productos en Shopify con tag "grosor-type"');

    return {
      standard: {
        name: 'Estándar',
        price: 0,
        description: 'Grosor estándar para la mayoría de las graduaciones. Configuración temporal hasta crear productos en Shopify.',
        isDefault: true
      },
      reducido: {
        name: 'Reducido',
        price: 15,
        description: 'Grosor reducido para mayor comodidad estética. Configuración temporal hasta crear productos en Shopify.',
        isDefault: true
      }
    };
  }

  shouldSkip() {
    // Solo mostrar si se eligieron progresivos o monofocales
    const needsThickness = this.configurator.configuration.lensType === 'progressive' ||
                          this.configurator.configuration.lensType === 'monofocal';
    return !needsThickness;
  }

  render() {
    const container = document.getElementById('thickness-options');
    if (!container) return;
    if (!this.configurator.config || !this.configurator.config.thickness || Object.keys(this.configurator.config.thickness).length === 0) {
      console.warn('⚠️ Grosores no cargados dinámicamente — usando configuración básica por defecto.');
      this.configurator.config = this.configurator.config || {};
      this.configurator.config.thickness = this.getBasicThickness();
    }

    container.innerHTML = '';

    // Orden deseado para mostrar los grosores
    const preferredOrder = ThicknessStep.STEP_CONFIG.PREFERRED_ORDER || ['standard', 'reducido'];
    const thicknessMap = this.configurator.config.thickness || {};
    const isMultiple = Boolean(ThicknessStep.STEP_CONFIG.MULTI_SELECT);
    container.dataset.multiple = isMultiple.toString();

    preferredOrder.forEach(key => {
      if (thicknessMap[key]) {
        const card = this.createOptionCard(key, thicknessMap[key], 'thickness', isMultiple);
        container.appendChild(card);
      }
    });

    // Añadir cualquier otro grosor que no esté en preferredOrder
    Object.entries(thicknessMap).forEach(([key, thicknessOption]) => {
      if (!preferredOrder.includes(key)) {
        const card = this.createOptionCard(key, thicknessOption, 'thickness', isMultiple);
        container.appendChild(card);
      }
    });
  }

  parsePrice(product) {
    if (!product.variants || product.variants.length === 0) return 0;
    const variant = product.variants[0];
    if (variant.price) return parseFloat(variant.price);
    return 0;
  }
}

// Hacer disponible globalmente
window.ThicknessStep = ThicknessStep;
